import React from "react";
import PageWrapper from "../components/PageWrapper";
import Seo from "../components/Seo";
import OnboardingForm from "../sections/onboarding/OnboardingForm";

const OnboardingPage = () => (
  <>
    <Seo
      title="Onboarding — Dioscuro"
      pathname="/onboarding"
    />
    <PageWrapper>
      <OnboardingForm />
    </PageWrapper>
  </>
);

export default OnboardingPage;
